// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"f10b9840","769":"0718bb6a"}[chunkId] + ".chunk.js";
};